<template>
    <div :class="option.type=='prepend' ? 'TTL-input TTL-prepend' : 'TTL-input TTL-append'" :style="{width:option.width}">
    <el-input class="inputType" v-model="inputvalue" :placeholder="option.placeholder" :clearable="option.clearable" @input="InputData">
    <template #prepend v-if="option.type=='prepend'">
        <span v-if="option.childtype=='title'">{{option.childname}}</span>
        <div class="TTL-select" v-if="option.childtype=='select'">
        <el-select v-model="selectvalue" placeholder="请选择" @change="changeData">
        <el-option v-for="(item,index) in selectlist" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
        </div>
    </template>
    <template #append v-if="option.type=='append'">
        <span v-if="option.childtype=='title'">{{option.childname}}</span>
        <div class="TTL-select" v-if="option.childtype=='select'">
        <el-select v-model="selectvalue" placeholder="请选择" @change="changeData">
        <el-option v-for="(item,index) in selectlist" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
        </div>
    </template>
    </el-input>
    </div>
</template>

<script>
export default {
  props: ['value','option','svalue','slist'],
  data() {
      return {
          inputvalue: this.value,
          selectvalue: this.svalue,
          selectlist: this.slist,
          option: {
              width:this.option && this.option.width ? this.option.width : '250px',
              type:this.option && this.option.type ? this.option.type : 'append',
              childtype:this.option && this.option.childtype ? this.option.childtype : 'title',
              childname:this.option && this.option.childname ? this.option.childname : '单位',
              placeholder:this.option && this.option.placeholder ? this.option.placeholder : '请填写数据',
              clearable: this.option && this.option.clearable ? this.option.clearable : false,
              isinput: this.option && this.option.isinput ? this.option.isinput : false,
          }
      }
  },

  watch: {
      value(val) {
          this.inputvalue=val;
      },
      svalue(val) {
          this.selectvalue=val;
      },
      slist(val) {
          this.selectlist=val;
      },
  },

  mounted() {
      
  },

  methods: {

      /** 输入框变动 **/
      InputData() {
          if(!this.option.isinput) return false; //数据输入时开关关闭时，不往下执行
          this.$emit('finish',{type:'input',value:this.inputvalue});
      },

      /** 切换选择单位数据 **/
      changeData() {
          this.$emit('finish',{type:'change',value:this.selectvalue});
      },

  }

}
</script>

<style scoped>
::v-deep(.inputType .el-input__wrapper) {background-image:none !important;padding-left:20px !important;}
::v-deep(.el-input-group--append .el-input-group__append .el-select .el-input .el-input__wrapper) {box-shadow:none !important;}
::v-deep(.el-input-group--append .el-input-group__append .el-select .el-input.is-focus .el-input__wrapper) {box-shadow:none !important;}
::v-deep(.el-input-group--prepend .el-input-group__prepend .el-select .el-input .el-input__wrapper) {box-shadow:none !important;}
::v-deep(.el-input-group--prepend .el-input-group__prepend .el-select .el-input.is-focus .el-input__wrapper) {box-shadow:none !important;}
::v-deep(.el-input-group--append .el-input-group__append .el-select .el-input .el-input__inner) {text-align: center;}
::v-deep(.TTL-prepend .el-input-group__prepend) {color:#333333;}
::v-deep(.inputType .el-input__inner) {text-align: center !important;}
</style>